// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\ntable[data-v-65b2eeca] {\n  border-collapse: separate;\n  border-spacing: 0;\n}\nthead[data-v-65b2eeca] {\n  position: sticky;\n  top: 0;\n}\n.table-wrapper[data-v-65b2eeca] {\n  max-height: 580px;\n  overflow-y: auto;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
